import {
  CRM_PRODUCT_SIGN_UP_PAGE_LINK,
  MARKETER_PRODUCT_SIGN_UP_PAGE_LINK,
  DEV_PRODUCT_SIGN_UP_PAGE_LINK,
  PROJECTS_PRODUCT_SIGN_UP_PAGE_LINK,
  NEW_SOFT_SIGNUP_LINK
} from "constants/links";
import * as Sentry from "@sentry/nextjs";

export const CRM_PRODUCT_TYPE = "CRM product";
export const MARKETER_PRODUCT_TYPE = "Marketer product";
export const PROJECTS_PRODUCT_TYPE = "Projects product";
export const DEV_PRODUCT_TYPE = "Dev product";
export const WORK_MANAGEMENT_PRODUCT_TYPE = "Work management product";

export const CRM_PRODUCT_VALUE = "crm";
export const MARKETER_PRODUCT_VALUE = "marketer";
export const PROJECTS_PRODUCT_VALUE = "projects";
export const DEV_PRODUCT_VALUE = "dev";

export const PRODUCT_TYPES = [
  CRM_PRODUCT_TYPE,
  MARKETER_PRODUCT_TYPE,
  PROJECTS_PRODUCT_TYPE,
  DEV_PRODUCT_TYPE,
  WORK_MANAGEMENT_PRODUCT_TYPE
];

export const PRODUCT_OPTIONS = [
  { value: CRM_PRODUCT_VALUE, text: CRM_PRODUCT_TYPE },
  { value: MARKETER_PRODUCT_VALUE, text: MARKETER_PRODUCT_TYPE },
  { value: PROJECTS_PRODUCT_VALUE, text: PROJECTS_PRODUCT_TYPE },
  { value: DEV_PRODUCT_VALUE, text: DEV_PRODUCT_TYPE }
];

const PRODUCT_SIGNUP_URLS = {
  [CRM_PRODUCT_VALUE]: CRM_PRODUCT_SIGN_UP_PAGE_LINK,
  [MARKETER_PRODUCT_VALUE]: MARKETER_PRODUCT_SIGN_UP_PAGE_LINK,
  [DEV_PRODUCT_VALUE]: DEV_PRODUCT_SIGN_UP_PAGE_LINK,
  [PROJECTS_PRODUCT_VALUE]: PROJECTS_PRODUCT_SIGN_UP_PAGE_LINK
};

export const getProductSignupURL = (productValue) => {
  const productSignupURL = PRODUCT_SIGNUP_URLS[productValue];
  if (!productSignupURL) {
    Sentry.captureMessage(`Product signup URL not found for product value: ${productValue}`);
    return NEW_SOFT_SIGNUP_LINK;
  }

  return productSignupURL;
};
